module.exports = __webpack_public_path__ + "static/media/impact-save-bags.aba9752f.svg";